import { all, put, call, takeEvery, select, spawn } from 'redux-saga/effects'
import Storage from '@aws-amplify/storage'
import Auth from '@aws-amplify/auth'
import moment from 'moment'
import { apiPaths, newAPIPaths } from '../../config'
import { http, notification, analytics } from '../../services/index'
import ClinicActions from './actions'
import {
  clinicSetState,
  getClinicDevices,
  deviceSetState,
  billingEligibilitySetState,
  getClinicDetail as getClinicDetailAction,
} from '../actions'
import { GET_CLINIC_PATIENTS_DB } from '../dashboard/sagas'
import { LISTEN_TO_DB_SOCKET } from '../dashboadLiveRR/sagas'
import { LISTEN_TO_SOCKET } from '../socket/sagas'

const getUser = (state) => state.user
const getClinic = (state) => state.clinic

export const getImageFromS3 = async (path, fileName) => {
  Storage.configure({
    AWSS3: {
      bucket: 'vc-profile',
      region: 'us-east-1',
    },
  })
  const image = await Storage.get(`${path}/${fileName}`, {})
    .then((result) => result)
    .catch((err) => window.log('ImageFromS3 error ', err))
  return image
}

const getClinicID = () =>
  http
    .get(apiPaths.Clinic.apiMyClinic, {})
    .then((res) => res)
    .catch((err) => {
      const { response } = err
      notification.error(
        `Something went wrong`,
        `${response && response.data ? response.data : err}`,
      )
      return []
    })

const getClinics = async () =>
  http
    .get(
      newAPIPaths.getAllClinic,
      {},
      {
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
      },
      'newAPIDomain',
    )
    .then((res) => res.data)
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return []
    })

const getClinicDetail = async (data) =>
  http
    .get(
      newAPIPaths.getOneClinic.replace('{clinic_id}', data.clinic_id),
      {},
      {
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
      },
      'newAPIDomain',
    )
    .then((res) => res.data)
    .catch((err) => {
      const { response } = err
      notification.error(`Something went wrong`, response || `Please contact support!`)
      return []
    })

const addClinic = async (dataObj) =>
  http
    .post(
      newAPIPaths.createClinic,
      dataObj,
      {
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
      },
      'newAPIDomain',
    )
    .then((res) => {
      notification.success(`Success`, 'Clinic created successfully')
      return { res }
    })
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })

const updateClinic = async (dataObj, showNotification) =>
  http
    .put(
      newAPIPaths.updateOneClinic.replace('{clinic_id}', dataObj.clinic_id),
      dataObj,
      {
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
      },
      'newAPIDomain',
    )
    .then((res) => {
      if (showNotification) {
        notification.success(`Success`, 'Clinic updated successfully')
      }
      return { res }
    })
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })

const importPCCResidentsCall = async (dataObj) =>
  http
    .post(
      newAPIPaths.apiImportPCCResidents,
      dataObj,
      {
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
      },
      'ehrAPIDomain',
    )
    .then((res) => ({ res }))
    .catch((err) => {
      if (err && err.response && err.response.data) {
        const {
          response: {
            data: { message },
          },
        } = err
        notification.error(`Something went wrong`, message || `Please contact support!`)
      } else {
        notification.error(`Something went wrong`, `Please contact support!`)
      }
      return { err }
    })

const importNotesCall = async (clinicId) =>
  http
    .post(
      newAPIPaths.apiImportNotes.replace('{clinic_id}', clinicId),
      {},
      {
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
      },
      'newAPIDomain',
    )
    .then((res) => ({ res: res.data || res }))
    .catch((err) => {
      if (err && err.response && err.response.data) {
        const {
          response: {
            data: { message },
          },
        } = err
        notification.error(`Something went wrong`, message || `Please contact support!`)
      } else {
        notification.error(`Something went wrong`, `Please contact support!`)
      }
      return { err }
    })

// --------------------------------------------------
// Not in use
// --------------------------------------------------

const sendDownloadReport = (role, dataObj) =>
  http
    .post(apiPaths[role].apiSendDownloadReport, dataObj, {})
    .then((res) => res)
    .catch((err) => {
      const { response } = err
      const data = response ? response.data : 'No response from server'
      notification.error(`Something went wrong`, `${data}`)
      return []
    })

const emailReport = (role, dataObj) =>
  http
    .post(apiPaths[role].apiEmailReport, dataObj, {})
    .then((res) => {
      notification.success('Success', 'Report sent successfully')
      return res
    })
    .catch((err) => {
      const { response } = err
      const data = response ? response.data : 'No response from server'
      notification.error(`Something went wrong`, `${data}`)
      return []
    })

export const getClinicFloors = async (payload) =>
  http
    .get(
      newAPIPaths.getOneClinicFloor.replace('{clinic_id}', payload.clinic_id),
      {},
      {
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
      },
      'newAPIDomain',
    )
    .then((res) => res.data)
    .catch(() => [])

const getClinicUsers = (role, dataObj) =>
  http
    .post(apiPaths[role].apiGetClinicUsers, dataObj, {})
    .then((res) => res)
    .catch((err) => {
      const { response } = err
      const data = response ? response.data : 'No response from server'
      notification.error(`Something went wrong`, `${data}`)
      return []
    })

// ------------------------- Not In Use -------------------------

// Function to get A List of Invoices from Server and Save it in Redux Store

export function* GET_CLINICID() {
  yield put(clinicSetState({ userClinicLoading: true }))
  const userClinic = yield call(getClinicID)
  if (userClinic.length > 0) {
    let selectedClinic = userClinic[0]
    const {
      location: { hostname },
    } = window
    if (
      typeof Storage !== 'undefined' &&
      localStorage.getItem(`selectedClinic-${hostname}`) &&
      localStorage.getItem(`selectedClinic-${hostname}`) !== 'undefined'
    ) {
      const id = localStorage.getItem(`selectedClinic-${hostname}`)
      const [firstIndex] = userClinic.filter((item) => item.id === parseInt(id, 10))
      if (firstIndex) {
        selectedClinic = firstIndex
      }
    }
    yield call(CHANGE_SELECTED_CLINIC, { payload: selectedClinic })
    yield put(clinicSetState({ clinicList: userClinic }))
  } else {
    yield call(CHANGE_SELECTED_CLINIC, { payload: userClinic })
    yield put(clinicSetState({ clinicList: [userClinic] }))
  }
}

export function* GET_CLINICS() {
  yield put(clinicSetState({ loading: true, clinicsList: [], clinicsListMap: {} }))
  const clinicsList = yield call(getClinics)
  const clinicsListMap = {}
  clinicsList.forEach((clinic) => {
    clinicsListMap[clinic.id] = clinic
  })
  yield put(clinicSetState({ loading: false, clinicsList, clinicsListMap }))
}

export function* GET_CLINIC_DETAIL({ payload }) {
  yield put(
    clinicSetState({
      clinicDetailLoading: true,
      clinicDetail: { floors: [], alert_recipients: [], daily_report_recipients: [] },
      userClinicImage: undefined,
    }),
  )
  const clinicDetail = yield call(getClinicDetail, payload)
  const userClinicImage = clinicDetail.logo
    ? yield call(getImageFromS3, 'clinic', clinicDetail.logo)
    : undefined
  yield put(clinicSetState({ clinicDetailLoading: false, clinicDetail, userClinicImage }))
}

export function* ADD_CLINIC(dataPayload) {
  const { payload } = dataPayload
  yield put(clinicSetState({ loading: true }))
  const { err } = yield call(addClinic, payload)
  if (err) {
    return yield put(clinicSetState({ loading: false, newClinic: 'error', redirect: false }))
  }
  yield put(clinicSetState({ loading: false, newClinic: 'success', redirect: true }))
  return yield call(GET_CLINICS)
}

export function* UPDATE_CLINIC(dataPayload) {
  const { payload, showNotification = true } = dataPayload
  yield put(clinicSetState({ loading: true, editedClinic: '', redirect: false }))
  const { err } = yield call(updateClinic, payload, showNotification)
  if (err) {
    return yield put(clinicSetState({ loading: false, editedClinic: 'error', redirect: false }))
  }
  yield put(getClinicDetailAction({ clinic_id: dataPayload.payload.clinic_id }))
  const clinicsList = yield call(getClinics)
  yield put(
    clinicSetState({ loading: false, editedClinic: 'success', redirect: true, clinicsList }),
  )
}

// --------------------------------------------------
// Not in use
// --------------------------------------------------

export function* GET_CLINIC_COMPLETE_PROFILE({ payload }) {
  yield put(deviceSetState({ loading: true, clinicDevicesList: [] }))
  yield put(clinicSetState({ clinicDetailLoading: true }))
  const { role } = yield select(getUser)
  const clinicDetail = yield call(getClinicDetail, payload, role)
  const clinicDevicesList = yield call(getClinicDevices, payload)
  const { logo } = clinicDetail
  const userClinicImage = yield call(getImageFromS3, 'clinic', logo)
  yield put(
    clinicSetState({ userClinic: clinicDetail, userClinicImage, clinicDetailLoading: false }),
  )
  yield put(deviceSetState({ clinicDevicesList }))
}

export function* CHANGE_SELECTED_CLINIC({ payload }) {
  analytics.setClinic({ id: payload.id, name: payload.name })

  yield put(clinicSetState({ userClinicLoading: true }))
  if (typeof Storage !== 'undefined') {
    const {
      location: { hostname },
    } = window
    const { id } = payload
    const oldClinicID = localStorage.getItem(`selectedClinic-${hostname}`)
    if (oldClinicID && +oldClinicID !== id) {
      const user = yield select(getUser)
      const userData = JSON.parse(localStorage.getItem(user.id)) || {}
      payload.changed = true
      localStorage.setItem(
        user.id,
        JSON.stringify({
          ...userData,
          userSettings: { ...userData.userSettings, selectedFloor: 'all' },
        }),
      )
    }
    localStorage.setItem(`selectedClinic-${hostname}`, id)
  }
  const { logo } = payload
  const userClinicImage = yield call(getImageFromS3, 'clinic', logo)
  yield put(clinicSetState({ userClinicLoading: false, userClinic: payload, userClinicImage }))
  yield call(GET_CLINIC_PATIENTS_DB, { payload: {} })
  if (payload.changed) {
    const { token } = yield select(getUser)
    yield spawn(LISTEN_TO_SOCKET, {
      payload: {
        jwtToken: token,
      },
    })
    yield spawn(LISTEN_TO_DB_SOCKET, {
      payload: {
        jwtToken: token,
      },
    })
  }
  // yield call(GET_CLINIC_FLOOR, { payload: {} })

  analytics.event({
    action: ClinicActions.CHANGE_SELECTED_CLINIC,
    category: 'clinic',
    label: 'onChange',
    value: { id: payload.id, name: payload.name },
  })
}

export function* UPDATE_SETTINGS() {
  yield put(clinicSetState({ loading: true }))
}

export function* GET_CLINIC_USERS({ payload }) {
  yield put(clinicSetState({ clinicUsersloading: true, clinicUsers: [] }))
  const { role } = yield select(getUser)
  const { data } = payload
  const clinicUsers = yield call(getClinicUsers, role, data)
  yield put(clinicSetState({ clinicUsersloading: false, clinicUsers }))

  analytics.event({
    action: 'get_clinic_users',
    category: 'clinical_report',
    label: 'onPageLoad',
    value: { data, role },
  })
}

export function* IMPORT_PCC_RESIDENTS({ payload }) {
  yield put(clinicSetState({ importPCCResidentsLoading: true }))
  const { res } = yield call(importPCCResidentsCall, payload)
  if (res && res.success) {
    const { clinicDetail, clinicsList } = yield select(getClinic)
    // update facility list data
    if (clinicsList.length > 0) {
      const facilityIndex = clinicsList.findIndex((item) => item.id === payload.clinic_id)
      clinicsList[facilityIndex].ehr_integration_status = res.ehr_integration_status
    }
    yield put(
      clinicSetState({
        clinicDetail: {
          ...clinicDetail,
          ehr_integration_status: res.ehr_integration_status,
          clinicsList,
        },
      }),
    )
    notification.success(`Success`, 'PCC Integration started successfully')
  }
  yield put(
    clinicSetState({
      importPCCResidentsLoading: false,
    }),
  )
}

export function* IMPORT_NOTES({ payload }) {
  const { clinic_id: clinicId } = payload
  yield put(clinicSetState({ importNotesLoading: true }))
  const { res } = yield call(importNotesCall, clinicId)
  if (res) {
    notification.success('Success', 'Notes import started successfully')
    yield put(getClinicDetailAction({ clinic_id: clinicId }))
  }
  yield put(clinicSetState({ importNotesLoading: false }))
}

export function* SEND_DOWNLOAD_REPORT({ payload }) {
  const { data } = payload
  const { role } = yield select(getUser)

  yield call(sendDownloadReport, role, data)
}

export function* SEND_EMAIL_REPORT({ payload }) {
  const { pdfFile, ...data } = payload.data
  yield put(billingEligibilitySetState({ reportSendLoading: true }))
  const { name, role } = yield select(getUser)

  const initials = name
    .split(' ')
    .map((val) => val.split('')[0])
    .join('')
  const patientInitials = 'U N'
    .split(' ')
    .map((val) => val.split('')[0])
    .join('')
  const fileName = `${initials}${moment().format('MMDD')}.pdf`

  const upload = yield call(uploadFile, 'vc-report', pdfFile, fileName, false, false)
  window.log('data', data)
  data.file_name = fileName
  data.sender_detail = `Circadia${moment().format('MMDD')}`
  data.url = 'circadia.health'
  let clinicDetails = {}
  let subjectLine
  let newFileName = ''
  if (data.report_type === 'clinical-daily-report') {
    clinicDetails = data.clinicDetail
    subjectLine = `Daily Report: ${data.selected_date.format('MM-DD-YYYY')} - ${clinicDetails.name}`
    newFileName = `${clinicDetails.name} - Daily Report - ${data.selected_date.format(
      'MM-DD-YYYY',
    )}.pdf`
    if (data.floorName && data.floorName !== 'All') {
      newFileName = `${clinicDetails.name} - Floor ${
        data.floorName
      } - Daily Report - ${data.selected_date.format('MM-DD-YYYY')}.pdf`
      subjectLine = `Daily Report: ${data.selected_date.format('MM-DD-YYYY')} - Floor ${
        data.floorName
      } of ${clinicDetails.name}`
    }
  }

  data.details = {
    subject_line: subjectLine,
    floor: data.floorName,
    patient_id: data.patient_id,
    patient_name: patientInitials,
    date: moment().format('MM-DD-YYYY'),
    sender_name: name,
    password: `Circadia${moment().format('MMDD')}`,
    newFileNameToDisplay: newFileName.replace(' ', ''),
  }

  if (Object.keys(clinicDetails)) {
    data.details.newFileNameToDisplay = `${
      clinicDetails.name
    }-Daily-Report-${data.selected_date.format('MM-DD-YYYY')}.pdf`
  }
  yield call(emailReport, role, data)
  yield put(billingEligibilitySetState({ reportSendLoading: false, reportMessage: true }))
  window.log(upload)

  analytics.event({
    action: 'send_report_via_email',
    category: 'clinical_reports',
    label: 'Send Report',
    value: data,
  })
}

export function* SEND_EMAIL_BILLING_REPORT({ payload }) {
  const { pdfFile, ...data } = payload.data
  yield put(billingEligibilitySetState({ reportSendLoading: true }))
  const { name, role } = yield select(getUser)

  const initials = name
    .split(' ')
    .map((val) => val.split('')[0])
    .join('')
  const patientInitials = 'U N'
    .split(' ')
    .map((val) => val.split('')[0])
    .join('')
  const fileName = `${initials}${moment().format('MMDD')}.pdf`
  const upload = yield call(uploadFile, 'vc-report', pdfFile, fileName, false, false)
  data.file_name = fileName
  data.sender_detail = `${initials}${moment().format('MMDD')}`
  data.url = 'circadia.health'
  data.details = {
    patient_id: data.patient_id,
    patient_name: patientInitials,
    date: moment().format('DD-MM-YYYY'),
    sender_name: name,
    password: `${initials}${moment().format('MMDD')}`,
  }
  yield call(emailReport, role, data)
  yield put(billingEligibilitySetState({ reportSendLoading: false, reportMessage: true }))
  window.log(upload, data)
}

export function* EMAIL_REPORT_LINK({ payload }) {
  const { data } = payload
  const { role } = yield select(getUser)

  yield call(emailReport, role, data)
}

export const uploadFile = async (
  path,
  file,
  fileName,
  isExtension = true,
  useDefaultBucket = true,
) => {
  const ext = getFileExtension(file.name)
  let fileNameToBeSent = `${fileName}`
  if (isExtension) {
    fileNameToBeSent = `${path}/${fileName}.${ext}`
  }
  if (useDefaultBucket) {
    await Storage.put(fileNameToBeSent, file).then((callback) => callback)
  } else {
    Storage.configure({
      AWSS3: {
        bucket: 'vc-report',
        region: 'us-east-1',
      },
    })
    await Storage.put(fileNameToBeSent, file)
      .then((callback) => callback)
      .catch((e) => window.log('error uploading file', e))

    Storage.configure({
      AWSS3: {
        bucket: 'vc-profile',
        region: 'us-east-1',
      },
    })
  }
  return `${fileName}.${ext}`
}

export const getFileExtension = (filename) => {
  const re = /(?:\.([^.]+))?$/
  const ext = re.exec(filename)[1]

  return ext
}

export function* GET_CLINIC_FLOOR({ payload }) {
  const clinicFloors = yield call(getClinicFloors, payload)
  yield put(clinicSetState({ clinicFloors }))
}

// ------------------------- Not In Use -------------------------

// Assigning constant Strings to Saga Functions, in order to access Saga Functions from Redux
export default function* rootSaga() {
  yield all([
    takeEvery(ClinicActions.GET_CLINICS, GET_CLINICS),
    takeEvery(ClinicActions.GET_CLINIC_DETAIL, GET_CLINIC_DETAIL),
    takeEvery(ClinicActions.ADD_CLINIC, ADD_CLINIC),
    takeEvery(ClinicActions.UPDATE_CLINIC, UPDATE_CLINIC),
    takeEvery(ClinicActions.IMPORT_PCC_RESIDENTS, IMPORT_PCC_RESIDENTS),
    takeEvery(ClinicActions.IMPORT_NOTES, IMPORT_NOTES),
    // ------------------------- Not In Use -------------------------
    takeEvery(ClinicActions.GET_CLINICID, GET_CLINICID),
    takeEvery(ClinicActions.GET_CLINIC_COMPLETE_PROFILE, GET_CLINIC_COMPLETE_PROFILE),
    takeEvery(ClinicActions.GET_CLINIC_USERS, GET_CLINIC_USERS),
    takeEvery(ClinicActions.SEND_DOWNLOAD_REPORT, SEND_DOWNLOAD_REPORT),
    takeEvery(ClinicActions.EMAIL_REPORT_LINK, EMAIL_REPORT_LINK),
    takeEvery(ClinicActions.SEND_EMAIL_BILLING_REPORT, SEND_EMAIL_BILLING_REPORT),
    takeEvery(ClinicActions.SEND_EMAIL_REPORT, SEND_EMAIL_REPORT),
    takeEvery(ClinicActions.CHANGE_SELECTED_CLINIC, CHANGE_SELECTED_CLINIC),
    takeEvery(ClinicActions.GET_CLINIC_FLOOR, GET_CLINIC_FLOOR),
    takeEvery(ClinicActions.UPDATE_SETTINGS, UPDATE_SETTINGS),
    // ------------------------- Not In Use -------------------------
  ])
}
